import { useLocation } from "react-router-dom";
import { sideMenuConfig } from "routing";
import { useBreadcrumbContext } from "contexts/BreadcrumbContext";

const BASE = "/shoup-community";

/**
 * Derives breadcrumb items from the current URL + sideMenuConfig + dynamic titles.
 * Returns an array of { label, path } objects.
 *
 * Pages can push human-readable labels for dynamic route segments via:
 *   const { setDynamicTitle } = useBreadcrumbContext();
 *   setDynamicTitle(communityId, community.name);
 */
export default function useBreadcrumbs() {
  const { pathname } = useLocation();
  const { dynamicTitles } = useBreadcrumbContext();

  if (!pathname.startsWith(BASE)) return [];

  const rest = pathname.slice(BASE.length).replace(/^\//, "");
  if (!rest) return [];

  const parts = rest.split("/").filter(Boolean);
  const items = [];
  let routeChildren = sideMenuConfig;
  let currentPath = BASE;

  for (const part of parts) {
    // Prefer exact path match; fall back to first :param route
    const match =
      routeChildren.find((r) => r.path === part) ??
      routeChildren.find((r) => r.path?.startsWith(":"));

    if (!match) break;

    currentPath = `${currentPath}/${part}`;

    items.push({
      label: dynamicTitles[part] ?? match.label,
      path: currentPath,
    });

    routeChildren = match.children ?? [];
  }

  return items;
}
